import { animate, style, transition, trigger } from "@angular/animations";

export const animation = trigger('slideInFromTop', [
  transition(':enter', [
    style({
      transform: 'scaleX(1.1) scaleY(0.95)',
      opacity: 0
    }),
    animate('150ms cubic-bezier(0.25, 0.46, 0.45, 0.94)',
      style({
        transform: 'scaleX(1) scaleY(1)',
        opacity: 1
      })
    )
  ]),
  transition(':leave', [
    animate('150ms ease-in',
      style({
        transform: 'scaleX(1.1) scaleY(0.95)',
        opacity: 0
      })
    )
  ])
])
